
<template>
    <div class='content'>
        <div class="container">
            example content
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
}
</script>

<style lang='scss' scoped>
.content {
 min-height: 100%;
 background: #fff;

 .container {
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
 }
}
</style>